import { render, staticRenderFns } from "./FundingSection.vue?vue&type=template&id=15ce930c"
import script from "./FundingSection.vue?vue&type=script&lang=ts"
export * from "./FundingSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports